import { Breadcrumb, Row, Col, Card, Button } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard, faEdit, faHome, faMobile, faTrash } from '@fortawesome/free-solid-svg-icons';
import React, { useState } from 'react'
import { Modal, Form, Card as AntCard, Button as AntButton, Upload, Input } from 'antd';
import { ExclamationCircleOutlined, InboxOutlined } from '@ant-design/icons'
import { useRecoilState, useRecoilValue, useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import { settingAlert, settingResponse, settings, settingsRefresh } from '../../../states/settings';
import { careerRefresh, career, editCareerModal, editCareerVal, careerTop } from '../../../states/career';
import { getHtml, getRawData } from '../../../services/utilities';
import { createCareer, deleteAbout, deleteCareer, updateSettings } from '../../../services/apiCalls';
import AlertToast from '../../../components/AlertToast';
import { dummyRequest } from '../../../services/utilities';
import AboutModal, { EditModal } from './Modal';
import { createAboutModal } from '../../../states/about';

const { Meta } = AntCard;
const Career = () => {
  const data = useRecoilValueLoadable(settings)
  const careers = useRecoilValueLoadable(career)
  const careerTops = useRecoilValueLoadable(careerTop)
  // console.log(data)
  // console.log(careers)
  // const about = useRecoilValueLoadable(career)
  const [showAlert, setShowAlert] = useRecoilState(settingAlert);
  const [response, setResponse] = useRecoilState(settingResponse)
  const setCreateModal = useSetRecoilState(createAboutModal);
  const setUpdateModal = useSetRecoilState(editCareerModal);
  const setRefresh = useSetRecoilState(settingsRefresh)
  const setCareerRefresh = useSetRecoilState(careerRefresh)
  const setValue = useSetRecoilState(editCareerVal)
  // const aboutData = about.state === "hasValue" && about.contents ? about.contents : []
  // const aboutData = about.state === "hasValue" && about.contents ? about.contents : []
  const settingData = data.state === "hasValue" ? data.contents : {}
  const careerData = careers.state === "hasValue" ? careers.contents : {} 
  const top = careerTops.state === "hasValue" ? careerTops.contents : {} 
  // const top = careers.lenght === 0 ? careers.top : {}
  const { mind, benefit } = careerData ? careerData  : {} 
  // const top = settingData
  // { benefit, top, settings, mind }
  const [viewModal, setViewModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [file, setFile] = useState("")
  const [file2, setFile2] = useState("")
  const [file3, setFile3] = useState("")
  const [file4, setFile4] = useState("")
  const [form] = Form.useForm()
  const [editor, setEditor] = useState("")
  const [editorDesc, setEditorDesc] = useState("")
  const { confirm } = Modal;

  const handleUpdate = () => {
    if (top.content) {
      const contentState = getRawData(top.content)
      setEditor(EditorState.createWithContent(contentState));
    }
    if (top.title) {
      const contentStateDesc = getRawData(top.title)
      setEditorDesc(EditorState.createWithContent(contentStateDesc));
    }
    setViewModal(true)
  }

  const handleEditModal = (val) => {
    setUpdateModal(true)
    setValue(val)
    setResponse({})
  }
  

  // const onFinishUpdate = async (val) => {
  //   const date = new Date()
  //   setLoading(true)
  //   const fd = new FormData();
  //   fd.append('title', val.title)
  //   fd.append('type', val.type)
  //   fd.append('content', getHtml(editor))
  //   fd.append('link', val.link_url)
  //   fd.append('file', file);
  //   fd.append('file2', file2);
  //   fd.append('file3', file3);
  //   fd.append('file4', file4);
  //   const res = await createCareer(fd)
  //   if (res.status) {
  //     setResponse({ message: res.message, title: "success" })
  //     setShowAlert(true)
  //     setRefresh(date.toTimeString())
  //     setViewModal(false)
  //     setFile("")
  //     setFile2("")
  //     setFile3("")
  //     setFile4("")
  //     setEditor("")
  //     form.resetFields()
  //   } else {
  //     setResponse({ message: res.message || res, title: "failed" })
  //     setShowAlert(true)
  //   }
  //   setLoading(false)
  // }
  const onFinishUpdate = async (val) => {
    console.log(val)
    const date = new Date()
    const fd = new FormData();
    // fd.append('title', val.title)
    fd.append('title', getHtml(editorDesc))
    fd.append('type', val.type)
    fd.append('link_url', val.link_url)
    fd.append('content', getHtml(editor))
    fd.append('file', file);
    fd.append('file2', file2);
    fd.append('file3', file3);
    fd.append('file4', file4);
    fd.append('id', val.id);
    setLoading(true)
    const res = await createCareer(fd)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setCareerRefresh(date.toTimeString())
      setViewModal(false)
      setEditor("")
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
    setLoading(false)
  }
  const onEditorStateChange = editorState => {
    setEditor(editorState);
  };
  const onEditorStateChanges = editorState => {
    setEditorDesc(editorState);
  };

  const confirmDelete = (id) => {
    confirm({
      title: `Are you sure you want to delete this Post?`,
      icon: <ExclamationCircleOutlined />,
      content: 'Click Ok to continue',
      onOk() {
        handleDelete(id)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleDelete = async (id) => {
    const date = new Date()
    const res = await deleteCareer(id)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setCareerRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }
  
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
        });
    }
  }
  const handleChange2 = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile2(info.file.originFileObj)
      });
    }
  }
  const handleChange3 = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile3(info.file.originFileObj)
      });
    }
  }
  const handleChange4 = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile4(info.file.originFileObj)
      });
    }
  };
  return (
    <div>
      <AlertToast showAlert={showAlert} setShowAlert={setShowAlert} response={response} page="About" />
      <AboutModal />
      <EditModal />
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item>Waya Career</Breadcrumb.Item>
            <Breadcrumb.Item active>Career</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Career Page</h4>
        </div>
      </div>
      <div className="table-settings mb-4">
        <Button variant="secondary" className="text-white me-3" onClick={handleUpdate}>
          Update Career Us<FontAwesomeIcon icon={faAddressCard} className="d-none d-sm-inline ms-1" />
        </Button>
        <Button variant="success" className="text-white me-3" onClick={() => setCreateModal(true)}>
          Create New Feature Content <FontAwesomeIcon icon={faMobile} className="d-none d-sm-inline ms-1" />
        </Button>
      </div>
      <Card border="light" className="bg-white shadow-sm mb-4">
        <Card.Body>
          <Row>
            <h5 className="mb-4 text-primary text-center">Career Waya Group</h5>
            <Col xs={12} md={7} xl={7} lg={7}>
              {/* <h6 className='text-center'>{top.title}</h6> */}
              <p className='text-center' dangerouslySetInnerHTML={{ __html: top.title }} />
              <p className='text-center' dangerouslySetInnerHTML={{ __html: top.content }} />
            </Col>
            <Col xs={12} md={5} xl={5} lg={5}>
              <Row>
                <Col xs={12} md={6} xl={6} lg={6}>
                  <img alt="Wayapaychat" src={`${top.image}`} />
                  <img alt="Wayapaychat" src={`${top.image4}`} />
                </Col>
                <Col xs={12} md={6} xl={6} lg={6}>
                  <img alt="Wayapaychat" src={`${top.image2}`} />
                  <img alt="Wayapaychat" src={`${top.image3}`} />
                </Col>
              </Row>
              {/* <img alt="Wayapaychat" src={`${top.image2}`} />
              <img alt="Wayapaychat" src={`${top.image4}`} /> */}
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Row>
        {mind && mind &&
        mind.map((b, index) => (
          <Col key={index} xs={12} xl={12} lg={12} md={12} className="text-center my-2">
            <h5 className="mb-4 text-primary text-center">{b.title}</h5>
            <div className="mb-4">
              <img alt="Wayapaychat" src={b.image} />
            </div>
              <Button size="sm" variant="success" className="text-white me-2" onClick={() => handleEditModal(b)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
              <Button size="sm" variant="primary" className="text-white" onClick={() => confirmDelete(b.id)}>
                <FontAwesomeIcon icon={faTrash} />
              </Button>
          </Col>))}
      </Row>
      <Row>
        {benefit && benefit &&
        benefit.map((b, index) => (
          <Col key={index} xs={12} xl={4} lg={4} md={4}>
            <h6 className='text-center'>{b.titel}</h6>
            <AntCard
              hoverable
              style={{ width: 240 }}
              // cover={<img alt="features" src={`${b.image}`} />}
            >
              <Meta title={b.title} description={b.content} />
              <Button size="sm" variant="success" className="text-white m-3" onClick={() => handleEditModal(b)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
              <Button size="sm" variant="primary" className="text-white m-3" onClick={() => confirmDelete(b.id)}>
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            </AntCard>
          </Col>))}
      </Row>
      {/* About Content start */}
      <Modal
        title="Update Career"
        centered
        visible={viewModal}
        footer={null}
        onCancel={() => setViewModal(false)}
      >
        <Form form={form} onFinish={onFinishUpdate} layout="vertical">
          <Form.Item name="title" initialValue={top.title} rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editorDesc}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 50,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChanges}
            />
          </Form.Item>
          <Form.Item label="Career" name="content" rules={[{ required: true }]}>
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 200,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          <Form.Item hidden name="id" initialValue={top.id}>
            <Input hidden />
          </Form.Item>
          <Form.Item name="type" hidden initialValue="top" rules={[{ required: true }]}>
            <Input hidden />
          </Form.Item>
          <Form.Item >
            <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
              <AntButton icon={<InboxOutlined />}>Upload Image</AntButton>
            </Upload>
          </Form.Item>
          <Form.Item >
            <Upload onChange={handleChange2} customRequest={dummyRequest} maxCount={1}>
              <AntButton icon={<InboxOutlined />}>Upload Image2</AntButton>
            </Upload>
          </Form.Item>
          <Form.Item >
            <Upload onChange={handleChange3} customRequest={dummyRequest} maxCount={1}>
              <AntButton icon={<InboxOutlined />}>Upload Image3</AntButton>
            </Upload>
          </Form.Item>
          <Form.Item >
            <Upload onChange={handleChange4} customRequest={dummyRequest} maxCount={1}>
              <AntButton icon={<InboxOutlined />}>Upload Image4</AntButton>
            </Upload>
          </Form.Item>
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Submit
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/* About Content end */}
    </div>
  )
}

export default Career
